module.exports = __webpack_public_path__ + "static/media/icon-robo.5cb06861.svg";